import { render, staticRenderFns } from "./SocietyContactContainer.vue?vue&type=template&id=7a1425c8&scoped=true"
import script from "./SocietyContactContainer.vue?vue&type=script&lang=js"
export * from "./SocietyContactContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1425c8",
  null
  
)

export default component.exports